import { render, staticRenderFns } from "./InvoicingDialog.vue?vue&type=template&id=2becf284&scoped=true&lang=pug&"
import script from "./InvoicingDialog.vue?vue&type=script&lang=ts&"
export * from "./InvoicingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicingDialog.vue?vue&type=style&index=0&id=2becf284&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2becf284",
  null
  
)

export default component.exports